import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { CurrenciesService } from 'src/pages/admin/settings/admin-setting-payments/currency/currencies.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { loadCurrencies, loadCurrenciesFailure, loadCurrenciesSuccess } from './currency.actions'

@Injectable()
export class CurrencyEffects {
  private actions$ = inject(Actions)
  private currencies = inject(CurrenciesService)
  private toaster = inject(ToasterService)


  loadCurrencies$ = createEffect(() => this.actions$.pipe(
    ofType(loadCurrencies),
    switchMap(action =>
      from(this.currencies.getCurrencies()).pipe(
        map(currencies => loadCurrenciesSuccess({
          tableKey: action.tableKey,
          currencies: currencies.data,
        })),
        catchAndLog(this.toaster, 'Unable to fetch currencies', loadCurrenciesFailure
      )))))
}
